import { Clock } from 'lucide-react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import type { TimelineBucket } from '../../types/analytics';

interface Props {
  timeline: TimelineBucket[];
  peakBucket: string;
}

export default function EngagementTimeline({ timeline, peakBucket }: Props) {
  if (timeline.length === 0) {
    return (
      <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
          <Clock className="w-5 h-5 text-primary" />
          Engagement Timeline
        </h3>
        <div className="h-48 flex items-center justify-center text-gray-500">
          <p>No activity data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-6">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
        <Clock className="w-5 h-5 text-primary" />
        Engagement Timeline
        {peakBucket && (
          <span className="ml-2 text-sm font-normal text-primary">
            Peak: {peakBucket}
          </span>
        )}
      </h3>
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={timeline} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" opacity={0.3} />
          <XAxis
            dataKey="bucket"
            tick={{ fontSize: 11, fill: '#9CA3AF' }}
            interval="preserveStartEnd"
          />
          <YAxis tick={{ fontSize: 11, fill: '#9CA3AF' }} allowDecimals={false} />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1F2937',
              border: 'none',
              borderRadius: '8px',
              color: '#F3F4F6',
              fontSize: 12,
            }}
            formatter={(value?: number, name?: string) => [value ?? 0, name === 'requests' ? 'Requests' : 'Votes']}
            labelFormatter={(label) => `Time: ${label}`}
          />
          <Legend
            formatter={(value) => value === 'requests' ? 'Requests' : 'Votes'}
            wrapperStyle={{ fontSize: 12 }}
          />
          <Area
            type="monotone"
            dataKey="requests"
            stackId="1"
            stroke="#10B981"
            fill="#10B981"
            fillOpacity={0.6}
          />
          <Area
            type="monotone"
            dataKey="votes"
            stackId="1"
            stroke="#6366F1"
            fill="#6366F1"
            fillOpacity={0.4}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
